import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button, TextField, Select } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList, Entry} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import uuid from 'react-uuid'


class Props extends SelfTimingEvent {
    back : () => void;
}

class EventSignup extends React.Component<Props & WithTranslation,any>
{
    

    constructor(props : any) 
    {
        super(props);
        this.state = {className : props.Classes[0].Name, firstName : '', lastName : '', team:'',tagNo:''};
    }
    onChange = (field : string) => (ev : React.ChangeEvent<HTMLInputElement>)=>{
        var o = {} as any;
        o[field] = ev.target.value;
        this.setState(o);
    }
    saveEntry = () => {
        let backend = new SelfTimingBackend();
        this.setState({view:'saving'});
        backend.saveEntry(this.props.Id,this.state.className, {
            Id: uuid(),
            FirstName : this.state.firstName,
            LastName : this.state.lastName,
            Team: this.state.team,
            TagNo : +this.state.tagNo
        }).then((result) => {
            this.setState({view:'saved'});
        });
    }
    render()
    {
        const {classes, t} = this.props as any;
        return <div style={{paddingLeft:'30px'}}><Button onClick={this.props.back} variant="contained" color="primary">Tillbaka</Button>
            <h3>Anmäl dig till {this.props.Name}</h3>
            {
            this.state.view == 'saving' ? this.renderSaving() : (this.state.view == "saved" ? this.renderSaved() : this.renderForm())
            }
            </div>;

    }
    renderSaving() 
    {
        return <div style={{lineHeight:'28px'}}>
        <LinearProgress/>
        <h4>Sparar anmälan...</h4>
        </div>;
    }
    renderSaved() 
    {
        return <div style={{lineHeight:'28px'}}>
        <h4>Din anmälan har sparats</h4>
        </div>;
    }

    renderForm() 
    {
        return <div style={{lineHeight:'28px'}}>
        <div>Klass</div>
        <div style={{flex:1}}><Select native label="Klass/Bana" onChange={this.onChange('className')} value={this.state.className}>
            {this.props.Classes.map((cl,idx) => {
                return <option value={cl.Name}>{cl.Name}, {(Math.round(cl.CourseLength/100)/10)+'km'}</option>
            })}
            </Select>
    </div>
    <div style={{display:'flex'}}>
        <div style={{width:'150px'}}><TextField label="Förnamn" value={this.state.firstName} onChange={this.onChange('firstName')}/></div>
        <div style={{flex:1}}><TextField label="Efternamn" value={this.state.lastName} onChange={this.onChange('lastName')}/></div>
    </div>
    <div style={{display:'flex'}}>
        <div style={{width:'150px'}}><TextField label="Team/Klubb" value={this.state.team} onChange={this.onChange('team')}/></div>
        <div style={{flex:1}}><TextField label="Transpondernummer" type="number" value={this.state.tagNo} onChange={this.onChange('tagNo')}/></div>
    </div>
    <div style={{display:'flex'}}>
        <div style={{width:'150px'}}><TextField label="Telefonnummer" value={this.state.phone} onChange={this.onChange('phone')}/></div>
        <div style={{flex:1}}><TextField label="Epost" value={this.state.mail} onChange={this.onChange('mail')}/></div>
    </div>
    <p>
    <Button variant="contained" color="primary" onClick={this.saveEntry}>Spara anmälan</Button><br/>
    <i style={{color:'#555555'}}>* genom att spara anmälan samtycker du samtidigt med att vi publicerar ditt namn i listor på nätet (anmälda, ev. startlistor samt resultatlistor)</i>
    </p>
</div>
    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: '#FFFFFF',
        color: '#000000'
      },
        cardHeaderTitle: {
            fontSize: '10px',
            lineHeight: '10px'
        }
  
});

export default withStyles(useStyles)(withTranslation()(EventSignup));